import { useEffect, useRef, useState } from 'react';

const CHECK_INTERVAL_MS = 15 * 60 * 1000;

async function fetchVersion(): Promise<string | null> {
  try {
    const res = await fetch(`/version.json?_=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return null;
    const data = await res.json();
    return data.version ?? null;
  } catch {
    return null;
  }
}

/** Detecta si se publicó una versión nueva del front mientras la pestaña estaba abierta. */
export function useVersionCheck(): boolean {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const baselineVersion = useRef<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      const current = await fetchVersion();
      if (cancelled || current === null) return;

      if (baselineVersion.current === null) {
        baselineVersion.current = current;
      } else if (current !== baselineVersion.current) {
        setUpdateAvailable(true);
      }
    };

    check();

    const interval = setInterval(check, CHECK_INTERVAL_MS);

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') check();
    };
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      cancelled = true;
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);

  return updateAvailable;
}
